import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AclModule } from '@app/acl/acl.module';
import { AdvancedSearchFormModule } from '@app/pcs/shared/components/advanced-search/advanced-search-form.module';
import { CalendarColumnComponent } from '@app/pcs/shared/components/calendar-column/calendar-column.component';
import { DossierNameLinkComponent } from '@app/pcs/shared/components/dossier-name-link-column/dossier-name-link.component';
import {
  InProgressNotificationComponent
} from '@app/pcs/shared/components/in-progress-notification/in-progress-notification.component';
import { PapTypeColumnComponent } from '@app/pcs/shared/components/pap-type-column/pap-type-column-component';
import { SidenavModule } from '@app/pcs/shared/components/sidenav/sidenav.module';
import { TabsNavModule } from '@app/pcs/shared/components/tab-nav/tabs-nav.module';
import { TrafficLightModule } from '@app/pcs/shared/components/traffic-light/traffic-light.module';
import { SharedModule } from '@app/shared/shared.module';
import { CalendarSmallModule } from '@dossier/shared/components/calendar-small/calendar-small.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    AclModule,
    TabsNavModule,
    AdvancedSearchFormModule,
    TrafficLightModule,
    CalendarSmallModule,
    SidenavModule
  ],
  declarations: [
    PapTypeColumnComponent,
    DossierNameLinkComponent,
    CalendarColumnComponent,
    InProgressNotificationComponent
  ],
  exports: [
    TabsNavModule,
    AdvancedSearchFormModule,
    TrafficLightModule,
    SidenavModule,
    InProgressNotificationComponent
  ]
})
export class PcsComponentsModule {
}
